import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Form, TextInput, Button, Loading } from 'carbon-components-react';
import { toaster } from '../../helpers/toaster';
import Select from "../../helpers/FixRequiredSelect";

import MyModal from '../../components/Modal/Modal';
import Label from '../../components/Label/Label';
import { selectStyles, formatReadOnlyStudyId } from '../../helpers/formUtils'
// api
import { getSimpleStudyList } from '../../api/studyListApi';
import { getAllGlobalRegistries } from '../../api/global-registries';

const RegistryDetailModal = ({
  mode = "create",
  open = false,
  registryIndex = null,
  registryData = null,
  studyIndex = null,
  onClose = () => {},
	confirmSave,
	confirmUpdate,
	registryLoading,
	setRegistryLoading,
  isStudyDetail,
  studyOrgStudyId,
  studyPgId
}) => {
  const [studyId, setStudyId] = useState({});
  const [registryId, setRegistryId] = useState("");
  const [globalRegId, setGlobalRegId] = useState({});
  const [studyList, setStudyList] = useState([]);
  const [globalRegistryList, setGlobalRegistryList] = useState([]);

  const [modalMode, setModalMode] = useState("");
  const [registryInfo, setRegistryInfo] = useState(null);

  const onlyAttachment = localStorage.getItem('only_attachment')

  const addBtnStyle = {
    padding: "5px 10px",
    height: "30px",
    minHeight: "30px",
    width: "fit-content",
    marginLeft:"18px",
  };

  const saveRegistry = (e) => {
    e.preventDefault();

    const { study, global_registry } = registryInfo;
    if (!study || !global_registry) {
      toaster("Registry data is not valid", "error")
      return;
    }
    if (modalMode === "create") {
      let regInfo = registryInfo;
      if (studyIndex) {
        regInfo = {
          ...regInfo,
          study: studyIndex,
        };
      }
      confirmSave(regInfo).then((data) => {
        setGlobalRegId({})
        if(isStudyDetail){
          setRegistryInfo({study: studyPgId})
        }
        else{
          setRegistryInfo(null)
        }
      })
    } else {
      confirmUpdate(registryIndex, registryInfo)
    }
  };

  const changeSelectedStudy = item => {
    setStudyId(item);
    setRegistryInfo({
      ...registryInfo,
      study: item?.value,
    });
  };
  
  const changeSelectedRegistry = item => {
    setGlobalRegId(item);
    setRegistryInfo({
      ...registryInfo,
      global_registry: item?.value,
    });
  };

	useEffect(() => {
    // load study list
		getSimpleStudyList().then(res => {
			if (res && res.length) {
				let studies = res.map(item => ({
          value: item.id,
          label: item.org_study_id,
        }));
        setStudyList(studies);
			}

      // load global-registry list
      getAllGlobalRegistries().then(res => {
        if (res && res.length) {
          let registries = res.map(item => ({
            value: item.id,
            label: item.name,
          }));
          setGlobalRegistryList(registries);
        }
        setRegistryLoading(false);
      }).catch(error => {
        toaster("Failed to get global registry list", "error")

        setRegistryLoading(false);
		}).catch(error => {
      toaster("Failed to get simple study list", "error")
      setRegistryLoading(false);
    });
    
     
    });
  }, []);
  
  useEffect(() => setModalMode(mode), [mode]);
  useEffect(() => {
    setRegistryInfo(registryData);

    if (registryData && registryData.study) {
      let study = studyList.find(item => parseInt(item.value) === registryData.study);
      setStudyId(study);
    } else {
      setStudyId(null);
    }

    if (registryData && registryData.global_registry) {
      let globalReg = globalRegistryList.find(item => item.value === registryData.global_registry);
      setGlobalRegId(globalReg);
    } else {
      setGlobalRegId(null);
    }

    if (registryData && registryData.registry_id) {
      let regId = globalRegistryList.find(item => item.value === registryData.registry_id);
      setRegistryId(regId);
    } else {
      setRegistryId(null);
    }
  }, [registryData]);
  
  useEffect(() => {
    setStudyId({label: studyOrgStudyId, value: studyPgId})
    setRegistryInfo({
      ...registryInfo,
      study: studyPgId,
    })
  }, [modalMode, studyPgId])

	const additionalProps = {
		className: 'some-class',
		onSubmit: saveRegistry
	};

  return (
    <MyModal
      modalHeading="Registry Details"
      size="sm"
      open={open}
      onRequestClose={onClose}
    >
      <RegistryModalContent>

        {
          registryLoading ?
            <Loading />
            :
            <></>
        }

				<Form {...additionalProps}>
            
          <PartWrapper>
            <InputWrapper>
              {(mode === "create" && !isStudyDetail) ?
                <>
                  <Label>Study*</Label>
                  <Select
                    id="studyId"
                    options={studyList}
                    onChange={e => changeSelectedStudy(e)}
                    value={studyId}
                    classNamePrefix="xogene"
                    className="multi-select"
                    styles={selectStyles()}
                    isSearchable
                    required
                  />
                </>
                :
                ( mode === "create" && isStudyDetail ) ?
                formatReadOnlyStudyId(studyOrgStudyId)
              : formatReadOnlyStudyId(studyId?.label)
              }
            </InputWrapper>
          </PartWrapper>
          

          <PartWrapper>
            <Label>Global Registry*</Label>
            <InputWrapper>
              <Select
                id="globalRegId"
                options={globalRegistryList}
                onChange={e => changeSelectedRegistry(e)}
                value={globalRegId}
                classNamePrefix="xogene"
                className="multi-select"
                styles={selectStyles()}
                isSearchable
                required
              />
            </InputWrapper>
          </PartWrapper>

          <div style={{ marginBottom: "18px" }}>
            <TextInput
              labelText="Registry ID*"
              id="registry_id"
              value={registryInfo?.registry_id || ""}
              onChange={e => setRegistryInfo({
                ...registryInfo,
                registry_id: e.target.value,
              })}
              required
              />
          </div>

          <div style={{ marginBottom: "18px" }}>
            <TextInput
              labelText="Summary Page URL"
              id="summaryPageURL"
              value={registryInfo?.trial_summary_page_url || ""}
              onChange={e => setRegistryInfo({
                ...registryInfo,
                trial_summary_page_url: e.target.value,
              })}
              />
          </div>

          <div style={{ marginBottom: "18px" }}>
            <TextInput
              labelText="Results Page URL"
              id="resultPageURL"
              value={registryInfo?.results_page_url || ""}
              onChange={e => setRegistryInfo({
                ...registryInfo,
                results_page_url: e.target.value,
              })} />
          </div>

          <ModalFooter>
            <Button 
              kind="secondary"
              onClick={onClose}
              style={addBtnStyle}  
            >Cancel</Button>

            <Button
              kind="primary"
              type="submit"
              style={addBtnStyle}
              disabled={onlyAttachment === "true"} 
            >{ (modalMode === "create") ? "Create Registry" : "Update Registry" }</Button>
          </ModalFooter>
        </Form>
      </RegistryModalContent>
    </MyModal>
  );
};

export default RegistryDetailModal;

const RegistryModalContent = styled.div`
  display: flex;
  flex-direction: column;
`

const ModalFooter = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`

const PartWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 18px;
`

const InputWrapper = styled.div`
  width: 100%;
`

const InputDisabled = styled.div`
  font-color: #666666;
  font-weight: bold;
  font-size: 1.2em;
`